import React from 'react';
import Modal from '../../../ui/Modal';

const formatDate = (s) => {
  if (!s) return '—';
  const d = new Date(s);
  if (isNaN(d)) return '—';
  return d.toLocaleDateString('ru-RU', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    timeZone: 'Europe/Moscow',
  });
};

const KZT = new Intl.NumberFormat('ru-KZ', { maximumFractionDigits: 2 });

function StatusBadge({ name }) {
  const n = (name || '').toLowerCase();
  let tone = 'neutral';
  if (/ожидает|новая/.test(n))           tone = 'warning';
  else if (/подтверждена|готов|оплачен/.test(n)) tone = 'success';
  else if (/отмен/.test(n))              tone = 'danger';
  else if (/в пути|производ/.test(n))    tone = 'info';
  return <span className={`appsv2__status appsv2__status--${tone}`}>{name || '—'}</span>;
}

export default function ApplicationsDetailsModal({ isOpen, onClose, application }) {
  if (!application) return null;

  const {
    order_number,
    client_name,
    contract_info,
    delivery_address,
    order_date,
    delivery_date,
    status_name,
    payment_status,
    items = [],
  } = application;

  // Normalize items
  const rows = items.map((it) => ({
    name:  it.product_name || it.product || it.name || it['Товар'] || '—',
    qty:   it.quantity || it.qty || it.count || it['Количество'] || 0,
    unit:  it.measure || it.unit || it['Ед. изм'] || '',
    price: Number(it.price || it.unit_price || it['Цена'] || 0),
    sum:   Number(it.total || it.sum ||
            (Number(it.quantity || it.qty || it['Количество'] || 0) *
             Number(it.price || it['Цена'] || 0))),
  }));
  const total = rows.reduce((acc, it) => acc + Number(it.sum || 0), 0);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Заявка №${order_number ?? '—'}`}
      subtitle={client_name}
      size="lg"
    >
      {/* Метаданные */}
      <div className="uimodal-field">
        <span className="uimodal-field__label">Договор</span>
        <span className="uimodal-field__value">{contract_info || '—'}</span>
      </div>
      <div className="uimodal-field">
        <span className="uimodal-field__label">Адрес доставки</span>
        <span className="uimodal-field__value">{delivery_address || '—'}</span>
      </div>

      <div className="uimodal-grid-2">
        <div>
          <span className="uimodal-field__label">Дата заказа</span>
          <span className="uimodal-field__value">{formatDate(order_date)}</span>
        </div>
        <div>
          <span className="uimodal-field__label">Дата доставки</span>
          <span className="uimodal-field__value">{formatDate(delivery_date)}</span>
        </div>
      </div>

      <div className="uimodal-grid-2">
        <div>
          <span className="uimodal-field__label">Статус заявки</span>
          <span className="uimodal-field__value">
            <StatusBadge name={status_name} />
          </span>
        </div>
        <div>
          <span className="uimodal-field__label">Статус оплаты</span>
          <span className="uimodal-field__value">
            <StatusBadge name={payment_status} />
          </span>
        </div>
      </div>

      {/* Таблица позиций */}
      <table className="uimodal-table">
        <thead>
          <tr>
            <th>Товар</th>
            <th>Кол-во</th>
            <th>Ед.</th>
            <th className="num">Цена</th>
            <th className="num">Сумма</th>
          </tr>
        </thead>
        <tbody>
          {rows.length > 0 ? (
            rows.map((it, idx) => (
              <tr key={idx}>
                <td>{it.name}</td>
                <td className="num">{it.qty}</td>
                <td>{it.unit}</td>
                <td className="num">{KZT.format(it.price)} ₸</td>
                <td className="num">{KZT.format(it.sum)} ₸</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5} style={{ textAlign: 'center', color: '#8C8077', padding: '20px' }}>
                Позиции отсутствуют
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="uimodal-total">
        <span className="uimodal-total__label">Общая сумма</span>
        <span className="uimodal-total__value">{KZT.format(total)} ₸</span>
      </div>
    </Modal>
  );
}
